import { createSelectionListViewContainer } from 'factories/SelectionListView'
import jobLabourRateActions from 'actions/jobLabourRates'
import Component from 'components/Jobs/Labour/FormView/SelectLabourRate'

export default createSelectionListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) => dispatch(jobLabourRateActions.getItems({ active: 'Active', ...params })),
  }),
})(Component)
